import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../services/firebase';
import Topbar from '../components/Topbar';
import Icon from '../components/Icon';
import Loading from '../components/Loading';
import './Dashboard.css';

export default function Dashboard({ onSelect, onOpenPlans, onLogout }) {
  const { t } = useTranslation();
  const [accounts, setAccounts] = useState([]);
  const [filter, setFilter] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchAccounts() {
      const snap = await getDocs(collection(db, 'accounts'));
      setAccounts(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setLoading(false);
    }
    fetchAccounts();
  }, []);

  const filtered = accounts.filter(a =>
    a.id.toLowerCase().includes(filter.toLowerCase()) ||
    (a.name && a.name.toLowerCase().includes(filter.toLowerCase()))
  );

  return (
    <div className="page">
      <Topbar onLogout={onLogout} />
      <main className="page-main">
        <div className="dash-head">
          <div>
            <h1>{t('dashboard.title')}</h1>
            <p className="dash-count">{t('dashboard.count', { count: filtered.length })}</p>
          </div>
          <div className="dash-actions">
            <button className="btn btn-ghost btn-sm" onClick={onOpenPlans}>
              <Icon name="package" size={16} />{t('dashboard.plans')}
            </button>
            <div className="dash-search">
              <Icon name="search" size={18} />
              <input
                type="text"
                placeholder={t('dashboard.searchPlaceholder')}
                value={filter}
                onChange={e => setFilter(e.target.value)}
              />
            </div>
          </div>
        </div>

        {loading ? (
          <div className="card"><Loading label={t('dashboard.loading')} /></div>
        ) : (
          <div className="card dash-card">
            <table className="client-table">
              <thead>
                <tr>
                  <th>{t('dashboard.colAccount')}</th>
                  <th>{t('dashboard.colPlan')}</th>
                  <th className="ta-center">{t('dashboard.colStatus')}</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(acc => (
                  <tr key={acc.id} className="row-click" onClick={() => onSelect(acc.id)}>
                    <td>
                      <div className="client-name">
                        <span className="client-avatar">{(acc.name || acc.id).slice(0, 2).toUpperCase()}</span>
                        {acc.name || t('common.dash')}
                      </div>
                    </td>
                    <td>{acc.subscription?.plan || t('common.dash')}</td>
                    <td className="ta-center">
                      <span
                        className={`status-dot ${acc.subscription?.status === 'active' || acc.subscription?.status === 'trialing' ? 'on' : 'off'}`}
                        title={acc.subscription?.status || t('dashboard.statusUnknown')}
                      />
                    </td>
                  </tr>
                ))}
                {filtered.length === 0 && (
                  <tr className="empty-row">
                    <td colSpan="3">{t('dashboard.empty')}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </main>
    </div>
  );
}
